import React, {Component} from 'react';
	

//题目日志操作类型
export const actionRecordMapType={
	question:[{
		label:'全部',
		value:'0'
	},{
		label:'添加题目',
		value:'1'
	},{
		label:'修改题目',
		value:'2'
	},{
		label:'上线题目',
		value:'3'
	},{
		label:'下线题目',
		value:'4'
	},{
		label:'删除题目',
		value:'5'
	},{
		label:'关联关系',
		value:'6'
	}],
	relation:[{
		label:'全部',
		value:'-1'
	},{
		label:'不上线',
		value:'0'
	},{
		label:'上线中',
		value:'1'
	},{
		label:'已上线',
		value:'2'
	},{
		label:'下线中',
		value:'3'
	},{
		label:'已下线',
		value:'4'
	},{
		label:'删除',
		value:'5'
	}]
}

const relationStatusMap={
	'0':'不上线',
	'1':'上线中',
	'2':'已上线',
	'3':'下线中',
	'4':'已下线',
	'5':'删除'
}

//题目记录表头
export const questionColumns=[
  { title: '操作时间', dataIndex: 'create_time'},
  { title: '操作人', dataIndex: 'username'},
  { title: '操作说明', dataIndex: 'type_name'},
];
//题目关联关系日志详情记录表头
export const questionRelationColumns=[
  { title: '操作类型', dataIndex: 'type_name'},
  { title: '章节', dataIndex: 'section'},
  { title: '操作说明', dataIndex: 'module'},
  { title: '任务ID', dataIndex: 'task_id'},
];
//关联关系记录表头
export const relationColumns=[
  { title: '章节', dataIndex: 'section'},
  { title: '最后操作时间', dataIndex: 'update_time',render:(text,record)=><span>{text=='0000-00-00 00:00:00'?record.create_time:text}</span>},
  { title: '状态', dataIndex: 'online_status',render:(text,record)=><span>{relationStatusMap[text]}</span>},
];

//关联关系日志详情记录表头
export const recordColumns=[
  { title: '操作类型', dataIndex: 'type_name'},
  { title: '时间', dataIndex: 'create_time'},
  { title: '操作人', dataIndex: 'username'},
  { title: '操作说明', dataIndex: 'type_name_group'},
  { title: '任务ID', dataIndex: 'task_id'},
];
//题目记录中关联关系type
export const relationTypeCheck=['200','201','202','203','210','211','220','230','231','240','241','250','251']



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/question_record/constData.js